import React, { useState } from "react";
import { Table } from "react-bootstrap";
import styles from "page.module.css";
import Pagination from "@mui/material/Pagination";

const CommonResultTable = ({ data, columnNames }) => {
  const itemsPerPage = 5; // Number of items per page
  const [currentPage, setCurrentPage] = useState(1);

  // Safety check for undefined or null data
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="text-center p-4">
        <p className="text-muted">No data available to display.</p>
      </div>
    );
  }

  // Safety check for columnNames
  if (!columnNames || typeof columnNames !== 'object') {
    return (
      <div className="text-center p-4">
        <p className="text-muted">Invalid column configuration.</p>
      </div>
    );
  }

  // Pagination logic
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = data.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <>
      <div className={styles.table_container}>
        <Table hover className="table-responsive">
          <thead>
            <tr>
              {Object.keys(columnNames).map((key) => (
                <th
                  key={key}
                  className={`text-center p-1 text-nowrap ${styles.bg_custom_4}`}
                  style={{
                    backgroundColor: "white",
                    borderRight: "2px solid white",
                  }}
                >
                  {columnNames[key]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, index) => (
              <tr key={index}>
                {Object.keys(columnNames).map((key) => (
                  <td
                    key={key}
                    style={{ wordWrap: "break-word", maxWidth: "200px" }}
                    className={`text-center align-middle ${
                      key === "action" ? "text-nowrap" : ""
                    }`}
                  >
                    {item[key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
        {/* Pagination */}
        <div className="d-flex justify-content-end flex-nowrap mt-3">
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
            siblingCount={1}
            boundaryCount={1}
          />
        </div>
      </div>
    </>
  );
};

export default CommonResultTable;
